<template>
  <section id="update-for-existing-enquiry">
    <p>Ok, thanks. If you would like to add additional information below for the advisor who picks it up to investigate.</p>
    <textarea name="comment" id="comment"></textarea>
    <SubmitButton btnText="Submit Enquiry" />
  </section>
</template>

<script>
import SubmitButton from '../components/SubmitButton'

export default {
  components: {
    SubmitButton
  }
}
</script>


// WEBPACK FOOTER //
// src/components/UpdateExistingEnquiryForm.vue